<template>
  <div class="settings-page pa-3">

    <div class="settings-section">
      <div class="settings-section__label">Account</div>
      <div class="settings-card">
        <div class="account-row">
          <div class="account-avatar">{{ user.email[0].toUpperCase() }}</div>
          <div class="account-info">
            <div class="account-email">{{ user.email }}</div>
            <div class="account-meta">Email address</div>
          </div>
        </div>
      </div>
    </div>

    <div class="settings-section">
      <div class="settings-section__label">Subscription</div>
      <div class="settings-card">
        <SubscriptionInfo />
      </div>
    </div>

    <div v-if="canPasswordChange" class="settings-section">
      <div class="settings-section__label">Security</div>
      <div class="settings-card">
        <ChangePassword />
      </div>
    </div>

  </div>
</template>

<script>
  import SubscriptionInfo from "@/components/modules/SubscriptionInfo.vue"
  import ChangePassword from "@/components/modules/ChangePassword.vue"

  export default {
    name: 'Settings',
    components: { ChangePassword, SubscriptionInfo },
    data: () => ({
      canPasswordChange: true
    }),
    computed: {
      user() {
        return this.$store.getters.user
      }
    },
  }
</script>

<style scoped>
.settings-page {
  max-width: 860px;
}

.settings-section {
  margin-bottom: 28px;
}

.settings-section__label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--app-text-muted);
  margin-bottom: 10px;
}

.settings-card {
  background: var(--app-bg-card);
  border: 1px solid var(--app-border);
  border-radius: 12px;
  padding: 16px 20px;
}

/* Account */
.account-row {
  display: flex;
  align-items: center;
  gap: 14px;
}
.account-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--primary-muted);
  color: var(--primary);
  font-size: 1rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.account-email {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--app-text);
}
.account-meta {
  font-size: 0.75rem;
  color: var(--app-text-muted);
  margin-top: 2px;
}
</style>
